<template>
  <div>
    <main class="main product-details-main">
      <PagesPath
        :pathTitle="blog.post.title"
        :pathTitle1="'بلاگ'"
        :pathTo1="'/products'"
        :pathTitle2="blog.post != null ? blog.post.title : ''"
      ></PagesPath>
      <div class="weblog-list-grid container text-right mt-md-3 mt-3">
        <section
          v-if="helpList"
          class="weblog-categories box-shaddow10 p-3 bg-white mb-3 showInMobile"
        >
        <div
              class=""
            >
              <h6 class="mr-2 weight-bold titleAsideSection fontsize-medium">
                آنچه در این مقاله میخوانید
              </h6>
            </div>
            <ul class="py-3">
              <li
                class="fontsize-mini weight-bold text-color-grey"
                style="cursor: pointer"
                @click="gotoSection('weblogDetailSummary')"
              >
                مقدمه
              </li>
              <li
                class="fontsize-mini weight-bold text-color-grey"
                style="cursor: pointer"
                @click="gotoSection(item.id)"
                v-for="(item, index) in helpList"
                :key="'item' + index"
              >
                {{ item.title }}
              </li>
            </ul>
        </section>
        <div class="welog-list-side">
          <section
            v-if="helpList"
            id="stickyHelpList"
            :class="{ 'side-end-is-reached': sideEndIsReached }"
            class="weblog-categories box-shaddow20 p-3 bg-white mb-3 hideIn768"
          >
            <div
              class=""
            >
              <h6 class="mr-2 weight-bold titleAsideSection fontsize-medium">
                آنچه در این مقاله میخوانید
              </h6>
            </div>
            <ul class="py-3">
              <li
                class="fontsize-mini weight-bold text-color-grey"
                style="cursor: pointer"
                @click="gotoSection('weblogDetailSummary')"
              >
                مقدمه
              </li>
              <li
                class="fontsize-mini weight-bold text-color-grey"
                style="cursor: pointer"
                @click="gotoSection(item.id)"
                v-for="(item, index) in helpList"
                :key="'item' + index"
              >
                {{ item.title }}
              </li>
            </ul>
          </section>
          <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
          <br v-if="blogStatus" />
          <section
            v-else
            class="weblog-categories box-shaddow20 p-3 bg-white mb-3"
          >
            <div
              class="d-flex "
            >
              <h6 class="mr-2 weight-bold titleAsideSection">
                دسته بندی ها
              </h6>
            </div>
            <ul class="py-3">
              <li
                v-for="(category, index) in blog.category"
                :key="'category' + index"
                class="text-color-grey"
              >
                <router-link
                  class="fontsize-mini weight-bold text-color-grey"
                  :to="{
                    name: 'weblogList',
                    params: { id: category.id, slug: category.slug },
                  }"
                >
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </section>
         
          <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
          <section
            class="d-flex flex-column latestWeblogs-container box-shaddow20 p-4 bg-white"
            id="latestWeblogsContainer"
            v-else-if="blog && blog.lastPost != ''"
          >
          <h6 class="mr-2 weight-bold titleAsideSection fontsize-medium">
            پست های اخیر
          </h6>
            <article
              v-for="(post, index) in blog.lastPost"
              :key="'post' + index"
              id="latestWeblogs"
              class="my-2"
            >
              <router-link
                :to="{
                  name: 'blogDetail',
                  params: { id: post.id, slug: post.slug },
                }"
              >
                <div class="latestWeblogs-img">
                  <img class="w-100 rounded-3" v-if="post.image" :src="post.image.url" alt="" />
                  <img
                    v-else
                    src="../../../assets/images/blog.jpg"
                    alt="blog"
                  />
                  <div class=" ">
                    <div class=" " style="width: 90%; margin: 0 auto;">

                      <h6 class="fontsize13 m-0 weight-bold fontsize-md-15 my-2 text-color-black">
                        {{ post.title.substr(0, 30) }}
                        {{ post.title.length > 30 ? "..." : "" }}
                      </h6>
                      <div class="categoryWeblog text-color-theme-dark  py-1 px-3">
                       <div class="borderCate">
                        {{ blog.post.category.name }}
                       </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </article>
          </section>
        </div>
        <div class="weblog-list-main mb-md-5 mb-4">
          <section class="weblog-details bg-white px-3 box-shaddow20 py-4 mb-5">
            <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
            <template v-else>
              <img
                v-if="blog.post.image != null"
                :src="blog.post.image.url"
                :alt="blog.post.title"
                class="articleImage"
              />
            </template>
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <div class="categoryWeblogmain fontsize-mini text-color-grey  my-3 rounded-3 py-3 px-3 rounded-5" >
                       <router-link to="/" class="borderCate text-color-theme-grey1">
                       {{ blog.post.category.name }}
                       </router-link>
                      </div>


            <b-skeleton v-if="blogStatus"></b-skeleton>
            <div
              v-else
              class="d-flex flex-wrap align-items-baseline mt-3 gap-20"
            >
              <div class="weblog-list-post-date">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7703 7.43587H8.89524C7.48896 7.43587 6.77734 6.63954 6.77734 5.06383V3.44293C6.77734 2.86687 6.84512 2.0423 7.44377 1.59049C7.94642 1.21774 8.66933 1.1895 9.73674 1.50012C11.1374 1.90676 12.3065 3.07583 12.7131 4.47647C13.0237 5.53823 12.9955 6.26679 12.6227 6.76379C12.1709 7.36809 11.3463 7.43587 10.7703 7.43587ZM8.4886 2.13267C8.25704 2.13267 8.07632 2.17785 7.95772 2.26821C7.73745 2.43199 7.63015 2.81604 7.63015 3.44293V5.06948C7.63015 6.33456 8.11585 6.59436 8.90088 6.59436H10.7759C11.3972 6.59436 11.7812 6.48705 11.9506 6.26679C12.1483 6.007 12.1314 5.48741 11.9111 4.72496C11.5835 3.61237 10.6234 2.64661 9.51084 2.32469C9.0929 2.19479 8.75404 2.13267 8.4886 2.13267Z"
                    fill="#105730"
                  />
                  <path
                    d="M6.67517 13.0841C6.37584 13.0841 6.07086 13.0615 5.76589 13.0107C3.45597 12.638 1.57528 10.7629 1.20254 8.453C0.722481 5.48231 2.63705 2.68104 5.56822 2.08239C5.79977 2.0372 6.02003 2.18404 6.07086 2.40995C6.11604 2.64151 5.9692 2.86177 5.74329 2.9126C3.26395 3.42089 1.63741 5.79293 2.04969 8.31746C2.36596 10.2716 3.95297 11.8586 5.90708 12.1748C8.4429 12.5815 10.8093 10.9493 11.3119 8.45865C11.3571 8.22709 11.583 8.08025 11.8089 8.12544C12.0405 8.17062 12.1873 8.39653 12.1421 8.62243C11.6056 11.2599 9.30135 13.0841 6.67517 13.0841Z"
                    fill="#105730"
                  />
                </svg>

                <span class="fontsize-mini text-color-grey mr-1">بازدید </span>
                <span class="haederBlogDetail fontsize-mini text-color-666">{{
                  blog.post.view_count
                }}</span>
              </div>
              <div class="weblog-list-post-date">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.0915 12.828C4.93336 12.828 4.76957 12.7884 4.62273 12.7094C4.30081 12.5399 4.10315 12.2011 4.10315 11.8396V11.0377C2.39754 10.8626 1.2793 9.60875 1.2793 7.81278V4.42419C1.2793 2.48138 2.58392 1.17676 4.52673 1.17676H10.1744C12.1173 1.17676 13.4219 2.48138 13.4219 4.42419V7.81278C13.4219 9.75559 12.1173 11.0602 10.1744 11.0602H8.04524L5.63931 12.6642C5.47553 12.7715 5.28352 12.828 5.0915 12.828ZM4.52673 2.01826C3.06962 2.01826 2.12645 2.96143 2.12645 4.41854V7.8072C2.12645 9.26431 3.06962 10.2075 4.52673 10.2075C4.75829 10.2075 4.95031 10.3995 4.95031 10.6311V11.834C4.95031 11.9074 4.99549 11.9413 5.02373 11.9583C5.05197 11.9752 5.10845 11.9921 5.17058 11.9526L7.68381 10.2809C7.75159 10.2357 7.83629 10.2075 7.92101 10.2075H10.1801C11.6372 10.2075 12.5804 9.26431 12.5804 7.8072V4.41854C12.5804 2.96143 11.6372 2.01826 10.1801 2.01826H4.52673Z"
                    fill="#105730"
                  />
                </svg>

                <span class="fontsize-mini text-color-grey mr-1">دیدگاه :</span>
                <span
                  v-if="blog.post.comments.length != 0"
                  class="fontsize-mini text-color-666"
                  >{{ blog.post.comments.length }}</span
                >
                <span v-else class="text-color-666 weight-bold pr-1">0</span>
              </div>
              <div class="weblog-list-post-date">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.33764 3.47018C5.10608 3.47018 4.91406 3.27816 4.91406 3.0466V1.35229C4.91406 1.12073 5.10608 0.928711 5.33764 0.928711C5.5692 0.928711 5.76122 1.12073 5.76122 1.35229V3.0466C5.76122 3.27816 5.5692 3.47018 5.33764 3.47018Z"
                    fill="#105730"
                  />
                  <path
                    d="M9.85717 3.47018C9.62562 3.47018 9.43359 3.27816 9.43359 3.0466V1.35229C9.43359 1.12073 9.62562 0.928711 9.85717 0.928711C10.0887 0.928711 10.2808 1.12073 10.2808 1.35229V3.0466C10.2808 3.27816 10.0887 3.47018 9.85717 3.47018Z"
                    fill="#105730"
                  />
                  <path
                    d="M12.3977 5.77977H2.79663C2.56507 5.77977 2.37305 5.58775 2.37305 5.3562C2.37305 5.12464 2.56507 4.93262 2.79663 4.93262H12.3977C12.6293 4.93262 12.8213 5.12464 12.8213 5.3562C12.8213 5.58775 12.6293 5.77977 12.3977 5.77977Z"
                    fill="#105730"
                  />
                  <path
                    d="M9.8574 13.0708H5.33923C3.27782 13.0708 2.0918 11.8848 2.0918 9.82338V5.02282C2.0918 2.96141 3.27782 1.77539 5.33923 1.77539H9.8574C11.9188 1.77539 13.1048 2.96141 13.1048 5.02282V9.82338C13.1048 11.8848 11.9188 13.0708 9.8574 13.0708ZM5.33923 2.62255C3.72399 2.62255 2.93895 3.40758 2.93895 5.02282V9.82338C2.93895 11.4386 3.72399 12.2237 5.33923 12.2237H9.8574C11.4726 12.2237 12.2577 11.4386 12.2577 9.82338V5.02282C12.2577 3.40758 11.4726 2.62255 9.8574 2.62255H5.33923Z"
                    fill="#105730"
                  />
                </svg>

                <span class="fontsize-mini text-color-666 mx-2">{{
                  blog.post.published_at | Date
                }}</span>
              </div>
            </div>
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <br v-if="blogStatus" />
            <h5
              id="weblogDetailSummary"
              v-else
              class="weblogDetailSummary my-4"
            >
              {{ blog.post.summary }}
            </h5>
            <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
            <div
              id="blogDetailBox"
              class="mt-5"
              v-else
              v-html="blog.post.body"
            ></div>
            <!-- <hr />
            <div class="d-flex justify-content-between">
              <span class="fontsize14 weight-bold ml-3 flex-shrink-0">برچسب ها:</span>
              <div  class="fontsize12 text-color-999">
                <span>#لباس</span>
                <span>#کفش</span>
                <span>#لباس-گرم</span>
                <span>#لباس-تابستانی</span>
                <span>#لباس</span>
                <span>#کفش</span>
                <span>#لباس-گرم</span>
                <span>#لباس-تابستانی</span>
              </div>
            </div> -->
            <hr />
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <div v-else class="d-flex justify-content-between">
              <span class="fontsize-small weight-bold ml-3"
                >اشتراک گذاری مطلب :</span
              >
              <section class="sotial-networks">
                <a
                  :href="
                    'whatsapp://send?text=' + encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <svg
                    id="Capa_1"
                    height="18"
                    style="enable-background: new 0 0 512 512"
                    version="1.1"
                    viewBox="0 0 512 512"
                    width="18"
                    x="0px"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    y="0px"
                  >
                    <path
                      d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456
                                C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504
                                c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792
                                c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184
                                c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392
                                c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352
                                c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024
                                c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568
                                c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z"
                      fill="#bbb"
                    />
                  </svg>
                </a>
                <!-- <a href="" class="mx-2">
                  <svg width="15" height="15" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">

                            <path d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160
                                C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48
                                h192c61.76,0,112,50.24,112,112V352z" fill="#bbb"/>
                    <path d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336
                                c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z" fill="#bbb"/>
                    <circle cx="393.6" cy="118.4" r="17.056" fill="#bbb"/>
                    </svg>
                </a> -->
                <a
                  :href="
                    'http://twitter.com/share?url=' +
                    encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <svg
                    id="Capa_1"
                    height="18"
                    style="enable-background: new 0 0 512 512"
                    version="1.1"
                    viewBox="0 0 512 512"
                    width="18"
                    x="0px"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    y="0px"
                  >
                    <path
                      d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
                                c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
                                c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
                                c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
                                c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
                                c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
                                C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
                                C480.224,136.96,497.728,118.496,512,97.248z"
                      fill="#bbb"
                    />
                  </svg>
                </a>
                <!-- <a href="" class="mx-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
                    <path fill="#bbb" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z"/>
                  </svg>
                </a> -->
                <a
                  :href="
                    'https://www.facebook.com/sharer/sharer.php?u=' +
                    encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <svg
                    id="Capa_1"
                    height="18"
                    style="enable-background: new 0 0 512 512"
                    version="1.1"
                    viewBox="0 0 512 512"
                    width="18"
                    x="0px"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    y="0px"
                  >
                    <path
                      d="M448,0H64C28.704,0,0,28.704,0,64v384c0,35.296,28.704,64,64,64h192V336h-64v-80h64v-64c0-53.024,42.976-96,96-96h64v80
                                h-32c-17.664,0-32-1.664-32,16v64h80l-32,80h-48v176h96c35.296,0,64-28.704,64-64V64C512,28.704,483.296,0,448,0z"
                      fill="#bbb"
                    />
                  </svg>
                </a>
              </section>
            </div>
          </section>

          <CommentSection />
        </div>
      </div>

      <ScrollToTop></ScrollToTop>
      <FooterButtons></FooterButtons>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import FooterButtons from "@/parts/Front/components/FooterButtons";
import PagesPath from "@/parts/Front/components/PagesPath";
import Weblog from "@/parts/Front/components/Weblog";
import CommentSection from "@/parts/Front/components/weblog/CommentSection";
import { BSkeleton, BSkeletonImg } from "bootstrap-vue";
import HomeBanners from "@/parts/Front/components/HomeBanners.vue";
export default {
  name: "WblogDetails",
  components: {
    CommentSection,
    ScrollToTop,
    FooterButtons,
    PagesPath,
    Weblog,
    BSkeleton,
    BSkeletonImg,
    HomeBanners,
  },
  beforeCreate() {
    this.$store.dispatch(
      "front/getBlogDetailFromServer",
      this.$route.params.id
    );
  },
  watch: {
    blog() {
      this.$nextTick(() => {
        let h2s = document.querySelectorAll("h2");
        let list = [];
        h2s.forEach((h2, index) => {
          h2.id = `title${index + 1}`;
          list.push({
            title: h2.innerText,
            id: `title${index + 1}`,
          });
        });
        this.helpList = list;
      });
    },
  },
  computed: {
    blog() {
      return this.$store.getters["front/getBlogDetail"];
    },
    blogStatus() {
      return this.$store.getters["front/getBlogDetailStatus"];
    },
    targetElement() {
      const targetElement = document
        .getElementById("latestWeblogsContainer")
        .getBoundingClientRect();
      return targetElement.top + targetElement.height;
    },
    advertiseBanners() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"].advertise;
      } else {
        return {};
      }
    },
  },
  data() {
    return {
      helpList: [],
      sideEndIsReached: false,
    };
  },
  methods: {
    gotoSection(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getBlogLink() {
      // گرفتن لینک این بلاگ برای اشتراک گزاری
      if (!this.blog.post) {
        return "";
      }
      return (
        window.location.hostname +
        "/blogs/" +
        this.blog.post.id +
        "/" +
        this.blog.post.slug
      );
    },
    isHelpListShow() {
      if (scrollY > this.targetElement) {
        this.sideEndIsReached = true;
      } else {
        this.sideEndIsReached = false;
      }
    },
    // تابع زیر برای اضافه کردن متا تگ و بالا بردن سئو است
  },
  mounted() {
    // در صورتی که کابر لاگین کرده بود و ایمیل داشت مقدار پیشفرض ایمیل را همان مفدار نشان بده
    if (this.$store.getters["front/getHomeData"] != null) {
      if (this.$store.getters["front/getHomeData"].user.user != false) {
        if (this.$store.getters["front/getHomeData"].user.user.email != null) {
          this.email = this.$store.getters["front/getHomeData"].user.user.email;
        }
      }
    }
    window.addEventListener("scroll", this.isHelpListShow);
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.blog ? this.blog.post.meta_description : false,
        },
        {
          property: "og:title",
          content: this.blog ? this.blog.post.title : false,
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>
.inputAlert {
  background-color: rgb(255 250 244);
}
/* افزودن استایل به کدهای اضافی قالب */
.articleImage {
  width: 100%;
  object-fit: fill;
}
.haederBlogDetail {
  margin-left: 5px;
}
.mr5 {
  margin-right: 5px;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.weblog-details >>> img {
  max-width: 100%;
}
@media screen and (min-width: 768px) {
  .side-end-is-reached {
    position: sticky;
    z-index: 1050;
    animation-name: stickyBox;
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }
  @keyframes stickyBox {
    0% {
      top: -100px;
    }
    100% {
      top: 80px;
    }
  }

}
@media screen and (max-width :768px) {
  .weblog-list-main{
    order: -1 !important;
  }
}
@media screen and (max-width: 550px) {
  .weblog-details >>> img {
    height: auto !important;
  }
}
.font-size-26 {
  font-size: 26px;
}
.latestWeblogs-container {
  border-radius: 20px;
  overflow: hidden;
}
#latestWeblogs {
  display: inline-block;

  width: 100%;
  transition: all 1s ease-in-out;

}
#latestWeblogs a {
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
}
/* #latestWeblogs .latestWeblogs-img {
  position: relative;
  height: 100%;
  object-fit: cover;
} */

/* #latestWeblogs .latestWeblogs-img:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000000b5;
} */

/* #latestWeblogs .latestWeblogs-img img {
  width: 100%;
  height: 100%;
} */
#latestWeblogs .latestWeblogs-info {
  position: absolute;
  top: 50%;
  right: 10px;
  /* transform: translateY(50%); */
}
#latestWeblogs .latestWeblogs-info h6 {
  color: #ffffff;
}
#latestWeblogs:hover .latestWeblogs-info h6 {
  color: #000000;
}
#latestWeblogs:hover .latestWeblogs-info svg path {
  fill: #000000;
}
/* #latestWeblogs:hover .latestWeblogs-img:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #97979769;
} */
.weblog-categories ul li:hover,
.weblog-categories ul li a:hover {
  color: var(--color-theme);
}

.weblog-list-post-date {
  background-color: var(--color-f0);
  padding: 7px 15px;
  border-radius: 10px;
  color: var(--color-444);
}
.weblogDetailSummary {
  border-radius: 10px;
  background-color: #10573017;
  font-size: 16px;
  line-height: 30px;
  padding: 15px;
}

.titleAsideSection{
  border-right: 2px solid var(--color-theme);
  padding: 0px 10px;
}

.welog-list-side ul li {
  list-style-type: disc ;
  list-style-position: outside;
  margin-right: 35px;
  font-size: 18px;

}
.welog-list-side li::marker {
  color: var(--color-theme2);
}

.latestWeblogs-img img{
  border-radius: 15px 15px 0 0 ;
}
.latestWeblogs{

}
.categoryWeblog{
  background-color: var(--color-f0);
  padding: 0px 10px;
  font-size: 14px;
  border-radius: 10px;
}
.borderCate{
  border-right: 1px solid var(--color-theme);
  padding: 0px 10px;
}
.categoryWeblogmain{
padding: 7px 13px;
background-color: var(--color-f0);
border-radius: 12px;
}
</style>
